/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-06-21 11:26:02
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Modal, TextContainer, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  active: boolean,
  onToggleModal: Function,
  widgetId: number,
  widgetName: string,
  actionType: string,
  loading: boolean,
  onAction: Function
};

type ComposedProps = Props & WithI18nProps;
// DONE
const ConfirmActionModal = (props: ComposedProps): Component<ComposedProps> => {
  const { i18n, active, actionType, widgetName, onToggleModal, loading, onAction } = props;

  // Not show popup if empty actionType
  if (_.isEmpty(actionType)) {
    return '';
  }

  return (
    <Modal
      open={active}
      onClose={onToggleModal}
      title={i18n.translate(`AdminHTML.PredictiveBundle.Management.${actionType}Widget_Title`)}
      primaryAction={{
        content: i18n.translate(`AdminHTML.PredictiveBundle.Management.${actionType}Widget_Button`),
        onAction: onAction,
        loading: loading
      }}
      secondaryActions={[
        {
          content: i18n.translate('AdminHTML.Common.Action.cancel'),
          onAction: onToggleModal
        }
      ]}>
      <Modal.Section>
        <TextContainer>
          <p>
            {i18n.translate(`AdminHTML.PredictiveBundle.Management.${actionType}Widget_Content`, {
              name: <TextStyle variation="strong">{widgetName}</TextStyle>
            })}
          </p>
        </TextContainer>
      </Modal.Section>
    </Modal>
  );
};
export default withI18n()(ConfirmActionModal);
